export const SET_FAVORITES = "SET_FAVORITES";
export const SET_PROPERTY_ID = "SET_PROPERTY_ID";
export const SET_FAVORITES_TOTAL = "SET_FAVORITES_TOTAL";
export const SET_LOADING_FAVORITES = "SET_LOADING_FAVORITES";
export const SET_PAGES_FAVORITES = "SET_PAGES_FAVORITES";
export const SET_NOT_LOGGED = "SET_NOT_LOGGED";



